<template>
  <div class="sessions">
    <div class="sessions-header-top">
      <v-btn icon
             color="primary"
             class="margin-right-small"
             @click="onBackClick"
      >
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <h1>Sessions</h1>
    </div>

    <div class="sessions-form">
      <div class="sessions-header">
        <h2>Session Limit: {{ sessionsSummary.sessionsLimit }}</h2>
        <h2>Active Sessions Count: {{ sessionsSummary.sessionsUsed }}</h2>
        <h2>Active sessions</h2>
      </div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                User
              </th>
              <th class="text-left">
                IP
              </th>
              <th class="text-left">
                File
              </th>
              <th class="text-left">
                Video Scopes
              </th>
              <th class="text-left">
                Last access
              </th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="session in sessionsSummary.activeSessions"
              :key="session.user + session.ip + session.path + session.isVideoScopeUsed"
            >
              <td>{{ session.user }}</td>
              <td>{{ session.ip }}</td>
              <td>{{ session.path }} </td>
              <td>{{ session.isVideoScopeUsed ? 'YES' : 'NO' }} </td>
              <td>{{ new Date(session.date).toLocaleString() }}</td>
              <td>
                <v-btn
                  text
                  color  = "error"
                  @click = "stopSession(session)"
                >
                  Stop session
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import { BusService } from '@/services/bus.service';
import { SNACKBAR_NAMES } from '@/models/snackbar-model';

export default {
  name: "Sessions",
  data() {
    return {
      sessionsSummary: { sessionsLimit: 0, sessionsUsed: 0, activeSessions: [] },
    };
  },
  computed: {
    ...mapState(['licenseService']),
  },
  async mounted() {
    this.initHandlers();
  },
  methods: {
    onBackClick() {
      this.$router.push('/')
    },
    initHandlers() {
      this.licenseService.onActiveSessionStatsChanged((newSessionsSummary) => {
        this.sessionsSummary = newSessionsSummary;
      });
      this.licenseService.onNotifyCloseRemoteSessionFailed(() => {
        BusService.snackbarSubject.next(SNACKBAR_NAMES.NOT_ABLE_TO_CLOSE_REMOTE_SESSION);
      });
    },
    async stopSession(toStop) {
      return await this.licenseService.removeSession(toStop.user, toStop.ip, toStop.path, toStop.isVideoScopeUsed);
    }
  }
}
</script>

<style scoped>
    .sessions {
        padding-top: 20px;
    }

    .sessions-header-top {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .sessions-form {
        margin-left: 10px;
        padding-top: 30px;
        width: 100%;
    }

    .sessions-form > {
        padding-top: 20px;
    }

    .sessions-header {
        padding-bottom: 10px;
    }

</style>
